<ul class="film_list list">
    {{#each cards}}
    <li class="film_item list" data-action='{{id}}'>
        <a class="film-link link js-open-modal" data-modal="1">
            <img src=https://image.tmdb.org/t/p/w500{{poster_path}} height="398" alt="{{title}}" class="film_image" data-id="{{id}}" loading="lazy"/>
        </a>
        <h1 class="film_title">{{title}}</h1>
        <p class="film_desc">{{newGenre}} | {{year}}</p>
    </li>
    {{/each}}
</ul>
